import { FormProvider } from 'react-hook-form';

import { IconButton, SlideOut, SlideOutControls } from '@hsp/react-component-library';

import { useCreateAddClientGroup } from '@p/security/users/client-group/components/slide-out/hook/form/createform';
import ClientGroupBody from '@p/security/users/client-group/components/slide-out/slide-out-body/body.component';
import { useClientGroupConfiguration } from '@p/security/users/client-group/hooks/configuration-hook';

import { s } from '@u/strings';

const AddClientGroupSlideOut = () => {
  const { handleSubmitted, isOpenClientGroup, setIsOpenClientGroup } = useClientGroupConfiguration();
  const methods = useCreateAddClientGroup();
  const { handleSubmit } = methods;

  return (
    <FormProvider {...methods}>
      <SlideOut
        isOpen={isOpenClientGroup}
        onClosed={() => {
          setIsOpenClientGroup(false);
          methods.reset();
        }}
        title="New Client Group">
        <form
          id="frm-new-client-group"
          onSubmit={handleSubmit((formData) => handleSubmitted(formData))}>
          <ClientGroupBody />
        </form>
        <SlideOutControls>
          <IconButton
            color="primary"
            form="frm-new-client-group"
            icon={'save'}>
            {s(['Site.Save'])}
          </IconButton>
          <IconButton
            className="ms-2"
            color="primary"
            form="frm-new-client-group"
            icon={'close'}>
            {s('Site.Cancel')}
          </IconButton>
        </SlideOutControls>
      </SlideOut>
    </FormProvider>
  );
};

export default AddClientGroupSlideOut;
